/**
 * **************************************************************************
 * Admin - tools service file
 *
 * Defines all http api calls required in tools page
 * Calls server apis and returns data to components
 * **************************************************************************
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  /****************** Variable declaration ******************/
  headers = new HttpHeaders({ 'isLoader': 'false' })

  /**
   * Constructor
   * @param httpClient
   * @param apiService
   */
  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService
  ) { }

  /**
   * Tool api's
   */
  public toolApis = this.apiService.TOOL_APIS;
  public toolUrl = this.apiService.KPID_URL + this.toolApis.TOOL;

  /**
   * Floating lic api's
   */
  public fltLicApis = this.apiService.FLT_LIC_SRV;
  public fltLicUrl = this.apiService.KPID_URL + this.fltLicApis.FLT_LIC;

  /**
   * Floating license server
   */
  getAllFltLic(): Observable<any> {
    return this.httpClient.get(this.fltLicUrl + this.fltLicApis.FLT_LIC_ALL);
  }

  /**
   * @param data
   * @returns
   */
  addFltLicType(data: any): Observable<any> {
    return this.httpClient.post(this.fltLicUrl + this.fltLicApis.FLT_LIC_ADD, data);
  }

  /**
   * @returns all tools data
   */
  getToolDet(): Observable<any> {
    return this.httpClient.get(this.toolUrl + this.toolApis.TOOL_ALL, { headers: this.headers });
  }

  /**
   * @param data
   * @returns adds the tool details to database
   */
  postAddTool(data: any): Observable<any> {
    return this.httpClient.post(this.toolUrl + this.toolApis.TOOL_ADD, data);
  }

  /**
   * @param id
   * @returns
   */
  updateTool(id: number, data: any): Observable<any> {
    return this.httpClient.patch(this.toolUrl + this.toolApis.TOOL_UPD(id), data, { headers: this.headers });
  }

  /** delete tool using tool id */
  deleteTool(id: any) {
    return this.httpClient.delete(this.toolUrl + this.toolApis.TOOL_DLT(id))
  }
}
